var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.2735L8.72671 0.333496L5.00004 4.06016L1.27337 0.333496L0.333374 1.2735L4.06004 5.00016L0.333374 8.72683L1.27337 9.66683L5.00004 5.94016L8.72671 9.66683L9.66671 8.72683L5.94004 5.00016L9.66671 1.2735Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCancel);
export default __webpack_public_path__ + "static/media/black-cancel.2c096d9551977e07cfb1c25a43e798fc.svg";
export { ForwardRef as ReactComponent };